export default class Pagination extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='pagination'>
        <div className='pagination__arrows'>
          <div className='pagination__arrow pagination__arrow-next flex-center' onClick={() => this.props.loadMore()}>
            Показать еще
          </div>
        </div>
      </div>
    );
  }
}
